import { StepContext, TextareaAutosize, Typography } from "@mui/material";
import React from "react";

const TextBox = ({text, setText, max, disabled=false}) => {
    const onChange = (e) =>{
    if (e.target.value.length < max){
     setText(e.target.value)
    }

    }
  return (
    <>
      <TextareaAutosize
        aria-label="description"
        onChange={onChange}
        disabled={disabled}
        minRows={4}
        value={text}
        placeholder="Description"
        style={{ width: "100%", border: "1px solid #E4E7EB", paddingBlock:'8px', paddingInline:"12px", color:disabled?"#00000061":'black'}}
      />
      <Typography variant="small" component={'p'} textAlign={'right'}>{text.length +'/'+max}</Typography>
    </>
  );
};

export default TextBox;
